import { retryRead } from '@shared/api/retry-read'
import { queryOptions } from '@tanstack/react-query'
import { apiFetch } from '@shared/api/http'
import { SalesAnalyticsSchema } from '@shared/contracts/seller-analytics'

export function salesAnalyticsQuery(query: string, enabled = true) {
  return queryOptions({
    queryKey: ['sales', 'analytics', query],
    enabled,
    retry: retryRead,
    queryFn: async () =>
      SalesAnalyticsSchema.parse(await apiFetch<unknown>(`/dashboard/sales?${query}`)),
  })
}
